import Page from '../../class/Page';
import Accordion from '../../components/accordion';

window.pageCurrent = class extends Page {
    init() {
        super.init();

        let jQuery = this.app.lib.jQuery;

        // animate badge chevron on open/close
        let badgeOpener = jQuery('.badge-body');
        badgeOpener.on('show.bs.collapse', function () {
            jQuery(this)
                .parent()
                .parent()
                .find('.collapse-indicator')
                .addClass('opened');
            jQuery('.collapse').each(function () {
                jQuery(this).collapse('hide');
            });
        });
        badgeOpener.on('hide.bs.collapse', function () {
            jQuery(this)
                .parent()
                .parent()
                .find('.collapse-indicator')
                .removeClass('opened');
        });

        // animate FAQ + on open/close
        let faqOpener = jQuery('.faq-question-body');
        faqOpener.on('show.bs.collapse', function () {
            jQuery(this)
                .parent()
                .parent()
                .find('.collapse-indicator')
                .addClass('opened');
        });
        faqOpener.on('hide.bs.collapse', function () {
            jQuery(this)
                .parent()
                .parent()
                .find('.collapse-indicator')
                .removeClass('opened');
        });

        this.initAllComponents('.accordion-item', Accordion);
    }
};
